import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useVersionsQuery = () =>
  useTypedQuery({ queryKey: UsersDashboardQueryKeys.versions, queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data });
